import { ssmRouterGuardService } from "@/shared/services/router-guard-service";
import Vue from "vue";
import Router from "vue-router";
import { RouterNames } from "./routernames";
Vue.use(Router);

export default new Router({
  routes: [
    {
      path: "/",
      redirect: "/main",
    },
    {
      path: "*",
      redirect: "/main",
    },
    {
      path: "/login",
      name: RouterNames.Login,
      component: () => import("@/views/login/login-formulario.vue"),
    },
    {
      path: "/lostpwd",
      name: RouterNames.lostpwd,
      component: () => import("@/views/lostpwdforms/pswlost.vue"),
    },
    {
      path: "/confirm-new-password/:token",
      name: RouterNames.confirm_new_password,
      component: () => import("@/views/lostpwdforms/pwdlost-confirm.vue"),
    },
    {
      path: "/instalacion",
      name: RouterNames.instalacion,
      component: () => import("@/views/instalacion/instalacion.vue"),
    },
    {
      path: "/main",
      redirect: "/main/home",
      name: RouterNames.mainlayout,
      component: () => import("@/views/mainlayout/main-layout.vue"),
      beforeEnter: ssmRouterGuardService.beforeEnter,
      children: [
        {
          path: "home",
          name: RouterNames.Home,
          component: () => import("@/views/home/home.vue"),
        },
        {
          path: "tablas",
          name: RouterNames.tablas_test,
          component: () =>
            import("@/components/titulopantalla/titulo-reactivo.vue"),
          children: [
            {
              path: "tabla/:id",
              name: RouterNames.table,
              component: () =>
                import("@/views/dynamic_tables/full_dynamic_table.vue"),
            },
          ],
        }, {
          path: "tbkn",
          name: RouterNames.tbkn,
          component: () =>
            import("@/components/titulopantalla/titulo-reactivo.vue"),
          children: [
            {
              path: "tbkn/:id",
              name: RouterNames.viewtbkn,
              component: () =>
                import("@/views/dynamic_views/dynamic_change_views.vue"),
            },
          ],
        },
        {
          path: "kanban",
          name: RouterNames.kanban,
          component: () =>
            import("@/components/titulopantalla/titulo-reactivo.vue"),
          children: [
            {
              path: "kanban/:id",
              name: RouterNames.viewKanban,
              component: () => import("@/views/dynamickanban/ViewKanban.vue"),
            },
            {
              path: "fullkanban/:id",
              name: RouterNames.FullViewKanban,
              component: () => import("@/views/dynamickanban/ViewKanban.vue"),
            },
          ],
        },
        {
          path: "enumeraciones",
          name: RouterNames.enumeraciones,
          component: () =>
            import("@/components/titulopantalla/titulo-reactivo.vue"),
          children: [
            {
              path: "enumeracion/:id_cabezera",
              name: RouterNames.enumeracion,
              component: () =>
                import("@/views/prioridades/GenericPrioridadesForm.vue"),
            },
          ],
        },{
          path: "informes",
          name: RouterNames.informes,
          component: () =>
            import("@/components/titulopantalla/titulo-reactivo.vue"),
          children: [
            {
              path: "actuaciones",
              name: RouterNames.actuaciones_informes,
              component: () =>
                import("@/views/informes/InformeActuaciones.vue"),
            },
            {
              path: "repositorio",
              name: RouterNames.repositorio_informes,
              component: () =>
                import("@/views/informes/InformeRepositorio.vue"),
            },
          ],
        },
        {
          path: "inventario",
          name: RouterNames.inventario,
          component: () => import("@/components/titulopantalla/titulo.vue"),
          children: [
            {
              path: "treeview",
              name: RouterNames.inventario_treeview,
              component: () =>
                import("@/views/inventario/categoria_invetario_view.vue"),
              children: [],
            },
            {
              path: "handler",
              name: RouterNames.handlerinventario_formulario,
              component: () =>
                import("@/views/inventario/handler_ficha_inventario.vue"),
              children: [
                {
                  path: "formulario/:id",
                  name: RouterNames.inventario_formulario,
                  component: () =>
                    import("@/views/inventario/ficha_inventario.vue"),
                  children: [],
                },
              ],
            },
          ],
        },
        {
          path: "administracion",
          name: RouterNames.administracion,
          component: () => import("@/components/titulopantalla/titulo.vue"),
          children: [
            {
              path: "usuarios",
              name: RouterNames.usuarios,
              component: () => import("@/components/titulopantalla/titulo.vue"),
              children: [
                {
                  path: "lista",
                  name: RouterNames.usuarioslista,
                  component: () => import("@/views/usuarios/UsuariosLista.vue"),
                  children: [],
                },
                {
                  path: "formulario/:id",
                  name: RouterNames.usuariosformulario,
                  component: () =>
                    import("@/views/usuarios/UsuariosFormulario.vue"),
                  children: [],
                },
              ],
            },
            {
              path: "empresas",
              name: RouterNames.empresas,
              component: () => import("@/components/titulopantalla/titulo.vue"),
              children: [
                {
                  path: "formulario/:id",
                  name: RouterNames.empresasformulario,
                  component: () =>
                    import("@/views/empresas/empresasFormulario.vue"),
                  children: [],
                },
              ],
            },
            {
              path: "contadores",
              name: RouterNames.contadores,
              component: () => import("@/components/titulopantalla/titulo.vue"),
              children: [
                {
                  path: "formulario/:id",
                  name: RouterNames.contadoresformulario,
                  component: () =>
                    import("@/views/contadores/contadoresFormulario.vue"),
                  children: [],
                },
              ],
            },
            {
              path: "ambitos",
              name: RouterNames.ambitos,
              component: () => import("@/components/titulopantalla/titulo.vue"),
              children: [
                {
                  path: "formulario/:id",
                  name: RouterNames.ambitosformulario,
                  component: () =>
                    import("@/views/ambitos/ambitosFormulario.vue"),
                  children: [],
                },
              ],
            },
            {
              path: "tareas",
              name: RouterNames.tareas,
              component: () => import("@/components/titulopantalla/titulo.vue"),
              children: [
                {
                  path: "formulario/:id",
                  name: RouterNames.tareasFormulario,
                  component: () =>
                    import("@/views/tareas/tareasFormulario.vue"),
                  children: [],
                },
              ],
            },
            {
              path: "subambitos",
              name: RouterNames.subambitos,
              component: () => import("@/components/titulopantalla/titulo.vue"),
              children: [
                {
                  path: "formulario/:id",
                  name: RouterNames.subambitosformulario,
                  component: () =>
                    import("@/views/subambitos/subambitosFormulario.vue"),
                  children: [],
                },
              ],
            },
            {
              path: "planes",
              name: RouterNames.planes,
              component: () => import("@/components/titulopantalla/titulo.vue"),
              children: [
                {
                  path: "formulario/:id",
                  name: RouterNames.planesformulario,
                  component: () =>
                    import("@/views/planes/planesFormulario.vue"),
                  children: [],
                },
              ],
            },
            {
              path: "objetivos",
              name: RouterNames.objetivos,
              component: () => import("@/components/titulopantalla/titulo.vue"),
              children: [
                {
                  path: "formulario/:id",
                  name: RouterNames.objetivosformulario,
                  component: () =>
                    import("@/views/objetivos/objetivosFormulario.vue"),
                },
              ],
            },
            {
              path: "actuaciones",
              name: RouterNames.actuaciones,
              component: () =>
                import("@/components/titulopantalla/titulo-reactivo.vue"),
              children: [
                {
                  path: "formulario/:id",
                  name: RouterNames.actuacionesFormulario,
                  component: () =>
                    import("@/views/actuaciones/actuacionesFormulario.vue"),
                },
              ],
            },{
              path: "tickets",
              name: RouterNames.tickets,
              component: () =>
                import("@/components/titulopantalla/titulo-reactivo.vue"),
              children: [
                {
                  path: "formulario/:id",
                  name: RouterNames.ticketsFormularioUser,
                  component: () =>
                    import("@/views/tickets/TicketsFormularioUser.vue"),
                },{
                  path: "formulario/:id",
                  name: RouterNames.ticketsFormulario,
                  component: () =>
                    import("@/views/tickets/TicketsFormulario.vue"),
                },{
                  path: "kanban",
                  name: RouterNames.ticketsKanban,
                  component: () =>
                    import("@/views/tickets/ticketsKanban.vue"),
                }
              ],
            },
            {
              path: "departamentos",
              name: RouterNames.departamentos,
              component: () => import("@/components/titulopantalla/titulo.vue"),
              children: [
                {
                  path: "formulario/:id",
                  name: RouterNames.departamentosformulario,
                  component: () =>
                    import("@/views/departamentos/DepartamentosFormulario.vue"),
                  children: [],
                },
              ],
            },
            {
              path: "grupos",
              name: RouterNames.grupos,
              component: () => import("@/components/titulopantalla/titulo.vue"),
              children: [
                {
                  path: "lista",
                  name: RouterNames.gruposlista,
                  component: () => import("@/views/grupos/GruposLista.vue"),
                  children: [],
                },
                {
                  path: "formulario/:id",
                  name: RouterNames.gruposformulario,
                  component: () =>
                    import("@/views/grupos/GruposFormulario.vue"),
                  children: [],
                },
              ],
            },
            {
              path: "rol",
              name: RouterNames.rol,
              component: () => import("@/components/titulopantalla/titulo.vue"),
              children: [
                {
                  path: "lista",
                  name: RouterNames.rollista,
                  component: () => import("@/views/roles/RolesLista.vue"),
                  children: [],
                },
                {
                  path: "formulario",
                  name: RouterNames.rolformulario,
                  component: () => import("@/views/roles/RolesFormulario.vue"),
                  children: [],
                },
              ],
            },
            {
              path: "notificaciones/formulario",
              name: RouterNames.notificaciones,
              component: () =>
                import("@/views/notificaciones/NotificacionesForm.vue"),
            },
          ],
        },
        {
          path: "plataforma",
          name: RouterNames.plataforma,
          component: () => import("@/components/titulopantalla/titulo.vue"),
          children: [
            {
              path: "instalacion/formulario",
              name: RouterNames.instalacion_plataforma,
              component: () => import("@/views/instalacion/instalacion.vue"),
            },
            {
              path: "menu",
              name: RouterNames.menu_plataforma,
              component: () => import("@/components/titulopantalla/titulo.vue"),
              children: [
                {
                  path: "lista",
                  name: RouterNames.menu_plataforma_lista,
                  component: () =>
                    import("@/views/plataforma/menu/MenuLista.vue"),
                },
                {
                  path: "formulario/:id",
                  name: RouterNames.menu_plataforma_formulario,
                  component: () =>
                    import("@/views/plataforma/menu/MenuFormulario.vue"),
                  children: [],
                },
              ],
            },
            {
              path: "tablas",
              name: RouterNames.tablas,
              component: () =>
                import("@/components/titulopantalla/titulo-reactivo.vue"),
              children: [
                {
                  path: "lista",
                  name: RouterNames.tablaslista,
                  component: () =>
                    import(
                      "@/views/dynamic_tables/views_settings/dynamic_tables_lista.vue"
                    ),
                  children: [],
                },
                {
                  path: "formulario/:id",
                  name: RouterNames.tablasformulario,
                  component: () =>
                    import(
                      "@/views/dynamic_tables/views_settings/dynamic_tables_formulario.vue"
                    ),
                  children: [],
                },
              ],
            },{
              path: "clientes",
              name: RouterNames.clientes,
              component: () => import("@/components/titulopantalla/titulo.vue"),
              children: [
                {
                  path: "formulario/:id",
                  name: RouterNames.clientesformulario,
                  component: () =>
                    import("@/views/plataforma/clientes/ClientesFormulario.vue"),
                  children: [],
                },
              ],
            },
          ],
        },
        {
          path: "mi_perfil",
          name: RouterNames.mi_perfil,
          component: () => import("@/views/usuarios/MiPerfil.vue"),
        },
        {
          path: "cerrar_session",
          name: RouterNames.cerrar_session,
          component: () => import("@/views/cerrar_session.vue"),
          children: [],
        },
      ],
    },
  ],
});
